export default __webpack_public_path__ + "static/media/tuto-step-2.bc007c68.gif";